/* EBH 2026-09-19 — o popup da newsletter cabe no telemóvel.

   O popup é da app Shopify Forms e desenha-se dentro de um shadow DOM
   (`<shopify-forms-embed>`): o CSS do tema não lá chega, por isso a folha
   entra por dentro, aqui.

   O que se corrige: em ecrã estreito a app empilha imagem e formulário e dá à
   imagem 320 px de altura FIXOS. Com o formulário por baixo (433 px) o popup
   ficava com 731 px num ecrã de 812 — praticamente um ecrã inteiro, e no
   telemóvel a sério, com a barra do browser, o rodapé com a política ficava
   cortado. A faixa passa a 170 px e o popup a ~600 px.

   ⚠️ A fotografia passa a `cover`: em `contain` (o que a app usa) uma faixa
      baixa deixava a foto pequenina ao meio, com bege dos dois lados. O
      `62%` é o que centra as garrafas na imagem de hoje — TROCAR A IMAGEM DO
      POPUP obriga a olhar outra vez para este número.
   ⚠️ Os nomes das classes da app trazem um sufixo gerado (`_grid_1q1d2_148`),
      que muda a cada versão da app: por isso os selectores são por PREFIXO.
      Se mesmo assim deixar de apanhar, o popup volta ao tamanho de hoje — não
      parte nada, deixa é de encolher.
   ⚠️ Agrupar com `setTimeout`, nunca com `requestAnimationFrame`: em separador
      escondido o rAF fica pendurado e o vigia nunca mais acorda. */
(function () {
  'use strict';

  var MARCA = 'ebh-popup-mobile';
  var FOLHA = [
    '@media screen and (max-width: 768px) {',
    '  [class*="_grid_"][class*="_left_"],',
    '  [class*="_grid_"][class*="_right_"] {',
    '    grid-template-rows: 170px min-content !important;',
    '  }',
    '  [class*="_gridItem_"]:nth-child(1) {',
    '    max-height: 170px !important;',
    '    background-size: cover !important;',
    '    background-position: center 62% !important;',
    '  }',
    '}'
  ].join('\n');

  /* Uma folha por shadow root, reposta se a app a levar à frente. */
  function vestir(host) {
    var raiz = host && host.shadowRoot;
    if (!raiz || raiz.getElementById(MARCA)) return;
    var folha = document.createElement('style');
    folha.id = MARCA;
    folha.textContent = FOLHA;
    raiz.appendChild(folha);
    /* O conteúdo do popup é redesenhado a cada passo do formulário; se a nossa
       folha desaparecer com ele, volta a entrar. */
    new MutationObserver(function () {
      if (!raiz.getElementById(MARCA)) raiz.appendChild(folha);
    }).observe(raiz, { childList: true });
  }

  function varrer() {
    var hosts = document.querySelectorAll('shopify-forms-embed');
    for (var i = 0; i < hosts.length; i++) vestir(hosts[i]);
  }

  varrer();

  /* A app monta-se depois da página (e às vezes só ao fim de segundos). */
  var pendente = false;
  new MutationObserver(function () {
    if (pendente) return;
    pendente = true;
    setTimeout(function () { pendente = false; varrer(); }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
